import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-auth": () => import("/app/middleware/admin-auth.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  "onboarding-guard": () => import("/app/middleware/onboarding-guard.ts"),
  "patient-auth": () => import("/app/middleware/patient-auth.ts"),
  "subscription-guard": () => import("/app/middleware/subscription-guard.ts"),
  "support-auth": () => import("/app/middleware/support-auth.ts")
}